/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import React, { useState, useEffect } from 'react'
import {Platform} from 'react-native';
import { Firestore, Crashlytics } from '../../firebase/config';
import { WebView } from 'react-native-webview';
import { Loader } from '../../components';


export default function Legal(props) {
const [loading, setLoading] = useState(true);
const [resource, setResource] = useState('');
const publicRef = Firestore.collection('Public');
const document = props.route.params.document;
const { navigation } = props;

useEffect(() => {
switch (document) {
case 'terms':
navigation.setOptions({title: 'Terms & Conditions'});
return fetchDocument('Terms & Conditions');
case 'privacy':
navigation.setOptions({title: 'Privacy Policy'});
return fetchDocument('Privacy Policy');
case 'attribution':
navigation.setOptions({title: 'Open Source Attribution'});
setResource('https://empire-distributing.web.app/oss-attribution/attribution.txt');
setLoading(false);
break;
}
},[]);


//Fetches public firestore document
const fetchDocument = (docName) => {
publicRef.doc(docName).get().then((doc) => {
const data = doc.data().url;
setResource(data);
setLoading(false);
}).catch((err) => {
console.error("Error getting " + docName);
Crashlytics.recordError(err);
})
}


if (loading) {
return (
<Loader />
)
}

if (resource) {
console.log(resource);
}
return (
<>
{resource &&
<>
{Platform.OS === 'web'?
<iframe src={resource} height={"100%"} width={"100%"} frameBorder={0}/>
:
<WebView
source={{uri: resource}}
/>
}
</>
}
</>
)
}
